var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable */
import React, { useState } from 'react';
import Sidebar from '../components/Sidebar';
import LoadingOverlay from 'react-loading-overlay-ts';
import { Spin } from 'antd';
import Packing from '../components/Packing';
import { Redirect } from 'react-router-dom';
import { useScreenVisibility } from '../utils/betaAccess';
var PackingScreen = function () {
    var _a = useState(false), isLoading = _a[0], setIsLoading = _a[1];
    var showLegacyPacking = useScreenVisibility().showLegacyPacking;
    if (!showLegacyPacking)
        return _jsx(Redirect, { to: '/packingv2' }, void 0);
    return (_jsx(LoadingOverlay, __assign({ active: isLoading, spinner: _jsx(Spin, {}, void 0) }, { children: _jsx(Sidebar, __assign({ setIsLoading: setIsLoading }, { children: _jsx(Packing, { setIsLoading: setIsLoading, isLoading: isLoading }, void 0) }), void 0) }), void 0));
};
export default PackingScreen;
